import React, { useState } from 'react';
import TemplateSidebar from '../templates/TemplateSidebar';  // Note: Matches your 'TemplateSidebar.js'
import WhatsAppTemplates from '../templates/WhatsAppTemplates';
import EmailTemplates from '../templates/EmailTemplates';
import SmsTemplates from '../templates/SmsTemplates';
import './TemplatesPage.css';

const TemplatesPage = () => {
  const [activeTab, setActiveTab] = useState('whatsapp');

  return (
    <div className="templates-page">
      <TemplateSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <div className="template-content">
        {activeTab === 'whatsapp' && <WhatsAppTemplates />}
        {activeTab === 'email' && <EmailTemplates />}
        {activeTab === 'sms' && <SmsTemplates />}
      </div>
    </div>
  );
};

export default TemplatesPage;